import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import AsyncTaskDeleteModal from './AsyncTaskDeleteModal'; // @ts-expect-error no-type

import AsyncCampaignEditPanel from 'collaboration-sidebar/components/AsyncCampaignEditPanel';
import AsyncConfirmDeleteCommentModal from 'collaboration-sidebar/components/AsyncConfirmDeleteCommentModal';
import { IS_EMBEDDED_COMMENTS_ONBOARDING_ENABLED } from '../constants/CollaborationSidebarStateProperties';
import DeepCommentingOnboardingClickables from '../features/deepCommenting/components/DeepCommentingOnboardingClickables';
import { useCollaborationSidebarState } from '../hooks';
import AsyncNotificationSettingsModal from './AsyncNotificationSettingsModal';
import { isUngated } from '../utils/auth';
import { NOTIFICATION_SETTINGS } from '../constants/gates';
export default function Modals({
  confirmDeleteCommentModalProps,
  taskDeleteModalProps,
  campaignCreatePanelProps,
  notificationSettingsModalProps,
  showDeleteCommentModal,
  showTaskDeleteModal,
  showCampaignCreatePanel,
  showNotificationSettingsModal,
  withoutSidebar,
  isReady,
  IFrameError
}) {
  const {
    collaborationSidebarState
  } = useCollaborationSidebarState();
  const isOnboardingActive = collaborationSidebarState[IS_EMBEDDED_COMMENTS_ONBOARDING_ENABLED];
  const isUngatedToSeeNotificationSettings = isUngated(NOTIFICATION_SETTINGS);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showDeleteCommentModal && /*#__PURE__*/_jsx(AsyncConfirmDeleteCommentModal, Object.assign({}, confirmDeleteCommentModalProps, {
      withoutSidebar: withoutSidebar,
      isReady: isReady,
      error: IFrameError
    })), showTaskDeleteModal && /*#__PURE__*/_jsx(AsyncTaskDeleteModal, Object.assign({}, taskDeleteModalProps)), showCampaignCreatePanel && /*#__PURE__*/_jsx(AsyncCampaignEditPanel, Object.assign({}, campaignCreatePanelProps)), showNotificationSettingsModal && isUngatedToSeeNotificationSettings && /*#__PURE__*/_jsx(AsyncNotificationSettingsModal, Object.assign({}, notificationSettingsModalProps)), isOnboardingActive && /*#__PURE__*/_jsx(DeepCommentingOnboardingClickables, {})]
  });
}